import { render, staticRenderFns } from "./seat-popover.vue?vue&type=template&id=2d5a7030"
import script from "./seat-popover.vue?vue&type=script&lang=js"
export * from "./seat-popover.vue?vue&type=script&lang=js"
import style0 from "./seat-popover.vue?vue&type=style&index=0&id=2d5a7030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports